import * as entity from '@common/domain/entities/RoleSite'
import { IColumnOptions, IDataEndPoint } from '../../../framework/interfaces/IEntity';
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { FieldType } from '../../../framework/core/Enums';
export class RoleSiteEndPoints extends entity.RoleSiteEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/role/roleSites/" + serviceCommand.context.entityId
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/addSite",
    //url: app.config.controllerRouteRoot + "/user/addRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        siteId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/removeSite",
    //url: app.config.controllerRouteRoot + "/user/removeRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        siteId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId
      }
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}

export class RoleSiteUserEndPoints extends entity.RoleSiteEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/roleSites/" + serviceCommand.context.entityId
    }
  };
  search?: IDataEndPoint = null;
}

export class RoleSiteFormFields extends entity.RoleSiteFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RoleSiteForm extends entity.RoleSiteForm {
  protected roleSiteFormEndPoints: RoleSiteEndPoints = new RoleSiteEndPoints();
  protected roleSiteFormFields: RoleSiteFormFields = new RoleSiteFormFields();
}

export class RoleSiteListColumns extends entity.RoleSiteListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length); 
      var selected: IColumnOptions = { field: "selected", width: "140px", fieldType: FieldType.Byte , name:"Selected"};
      var name: IColumnOptions = { field: "name", fieldType: FieldType.String, name: "Name", };
      selected.readOnly = false;
      selected.endPoints = new RoleSiteEndPoints();
      this.push(selected)
      this.push(name)
    } catch  { }
  }
}

export class RoleSiteUserListColumns extends entity.RoleSiteListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      var name: IColumnOptions = { field: "name", fieldType: FieldType.String, name: "Name", };
      this.push(name)
    } catch  { }
  }
}


export class RoleSiteList extends entity.RoleSiteList {
  protected roleSiteListEndPoints: RoleSiteEndPoints = new RoleSiteEndPoints();
  protected roleSiteListColumns: RoleSiteListColumns = new RoleSiteListColumns();
  public disableNavigation: boolean = true;
}

export class RoleSiteListPerUser extends entity.RoleSiteList {
  protected roleSiteListEndPoints: RoleSiteUserEndPoints = new RoleSiteUserEndPoints();
  protected roleSiteListColumns: RoleSiteUserListColumns = new RoleSiteUserListColumns();
  public disableNavigation: boolean = true;
}
